export const statisticData = [
  {
    id: "all",
    title: "Total lookups",
    brand: null,
    value: 0,
    description: "Bank inquiries received",
    isConnected: true,
    unit: "%"
  },
  {
    id: "email",
    title: "Match rate",
    value: 0,
    description: "Lookups with data returned",
    isConnected: true,
    unit: "%"
  },
  {
    id: "sms",
    title: "Total lookup fees",
    value: 0,
    description: "Charged from your balance",
    isConnected: true,
    unit: "$"
  },
  {
    id: "link",
    title: "Disputes prevented",
    value: 0,
    description: "Disputes avoided after lookup",
    isConnected: true,
    unit: "$"
  }
]
